import { render, staticRenderFns } from "./SendMixins.vue?vue&type=template&id=0c65759c&scoped=true"
import script from "./SendMixins.vue?vue&type=script&lang=js"
export * from "./SendMixins.vue?vue&type=script&lang=js"
import style0 from "./SendMixins.vue?vue&type=style&index=0&id=0c65759c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c65759c",
  null
  
)

export default component.exports